<template>

<div class="set" :class="{'is-multiple': isMultiple}" v-click-outside="onOutsideClick">

    <div class="set-items-item" v-if="is.loading">Loading...</div>

    <div class="set-items" v-if="!is.editing && !is.loading">
    
        <div class="set-items-item" v-for="item in selected" v-tooltip="'Click to remove'" v-on:click="onRemoveClick(item.value)" :key="item.value">

            <span>{{ item.text }}</span>

            <i class="fa fa-remove sets-items-item-remove" />

        </div>

    </div>

    <div class="set-input-wrapper" :class="{'is-searching': is.searching}" v-if="!is.loading">
        <input type="text" ref="input" v-model="search" class="set-input" :placeholder="placeholder" v-on:focus="onFocus" v-if="(is.editing || isMultiple) && canAddMore" autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false" />
        <i class="fa-solid fa-spinner fa-spin" v-if="is.searching" />
    </div>

    <div class="set-empty" v-if="!suggestions.length && expanded && this.search && !is.searching">No matches found.</div>

    <core-filter-advanced-builder-dropdown :is-scroll="true" :exclude="model" theme="set" :search="search" :options="optionsFinal" v-on:change="onSelect" v-if="expanded" />

</div>

</template>

<script>

import vClickOutside from 'v-click-outside'
import $filter from '@/filter'

export default {

	directives: {
		clickOutside: vClickOutside.directive
	},

    props: ['value', 'type', 'rule'],

    data: function() {

        return {
            is: {
                editing: true,
                loading: true,
                searching: false
            },
            model: [],
            search: '',
            expanded: false,
            options: [],
            suggestions: []
        }

    },

    created: function() {

        this.model = this.value

        if (this.model.length > 1 && !this.isMultiple) this.model = [this.model[0]]

        if (this.model.length) this.is.editing = false

        this.load()

    },

    computed: {

        optionsFinal: function() {

            if (this.isSearchOnly) {

                return this.suggestions

            } else {

                return this.options

            }

        },

        isSearchOnly: function() {

            return this.type.format.searchOnly

        },

        canAddMore: function() {

            return this.selected.length < this.options.length || this.isSearchOnly

        },

        isMultiple: function() {

            return this.$_.contains(['oneof', 'someof', 'allof'], this.rule.setting.logic)

        },

        selected: function() {

            var options = []

            this.$_.each(this.model, function(value) {

                options.push({
                    value: value,
                    text: $filter.cache(value) || value
                })

            })

            return options

        },

        placeholder: function() {

            var unit = this.type.lang.unit || ''

            if(unit) unit = ' ' + unit

            if (this.isSearchOnly) {

                return 'Search for' + unit + '...'

            } else {

                return 'Search or select' + unit + '...'

            }

        }

    },

    watch: {

        value: function(n) {

            this.model = n

            if (this.model.length) this.is.editing = false

        },

        search: function() {

            if (this.isSearchOnly) {

                this.suggest()

            }

        },

        model: function(n) {

            this.$emit('input', n)

        }

    },

    methods: {

        onTextClick: function() {

            this.is.editing = true

            this.$nextTick(function() {

                this.$refs.input.focus()

            }.bind(this))

        },

        onRemoveClick: function(value) {

            if (this.isMultiple) {

                var values = this.$util.copy(this.model)

                values.splice(values.indexOf(value), 1)

                this.$emit('input', values)

            } else {
                
                this.$emit('input', this.$util.copy([]))

                this.is.editing = true

                this.$nextTick(function() {

                    this.$refs.input.focus()

                }.bind(this))

            }

        },

        suggest: function() {

            if (this.search) {

                var params = this.$util.copy(this.$route.params)

                params.text = this.search

                this.is.searching = true

                this.$api.post(['users', 'filters', this.type.key.replace('.', '_')], params, {
                    cache: true
                }).then(function(response) {

                    if (this.is.searching) {

                        this.$_.each(response.options, function(option) {

                            $filter.cache(option.value, option.text)

                        }.bind(this))
                        
                        this.$vueset(this, 'suggestions', response.options)

                    }

                    this.is.searching = false

                }.bind(this))

            } else {

                this.suggestions = []

                this.is.searching = false

            }

        },

        load: function() {

            if (this.isSearchOnly) {

                this.is.loading = false

            } else if (this.type.set) {

                this.$_.each(this.type.set, function(text, value) {

                    $filter.cache(value, text)

                    this.options.push({
                        value: value,
                        text: text
                    })

                }.bind(this))

                this.is.loading = false

            } else {

                this.$api.post(['users', 'filters', this.type.key.replace('.', '_')], this.$route.params, {
                    cache: true,
                    nonblock: true
                }).then(function(response) {

                    this.$_.each(response.options, function(option) {

                        $filter.cache(option.value, option.text)

                    }.bind(this))

                    this.$vueset(this, 'options', response.options)

                    this.is.loading = false

                }.bind(this))

            }

        },

        onFocus: function() {

            this.expanded = true

        },
        
        onSelect: function(value) {

            if (!this.isMultiple) {

                this.$emit('input', [value])

            } else {

                var values = this.$util.copy(this.model)

                values.push(value)

                this.$emit('input', values)

            }

            this.expanded = false
            this.search = ''
            this.is.editing = false

        },

        onOutsideClick: function() {

            this.expanded = false
            this.search = ''
            if (this.isMultiple) this.is.editing = false

        }

    }

}

</script>

<style scoped>

.set {
    width: 100%;
}

.set.is-multiple {
    padding-top: 18px;
}

.set.is-multiple:after {
    display: block;
    content: '';
    position: absolute;
    width: 2px;
    top: -2px;
    height: 20px;
    left: 50%;
    margin-left: -1px;
    background-color: #22465A;
}

.set-items {
    display: grid;
    grid-gap: 4px;
}

.set.is-multiple .set-items {
    margin-bottom: 4px;
}

.set-items-item {
    padding: 2px 32px 2px 10px;
    font-size: 14px;
    line-height: 18px;
    display: flex;
    align-items: center;
    background-color: #fff;
    font-weight: 500;
    height: 40px;
    border-radius: 4px;
    width: 100%;
    background-color: rgba(0, 0, 0, 0.15);
    user-select: none;
    color: #fff;
    cursor: pointer;
}

.set.is-multiple .set-items-item {
    border-radius: 10px;
    padding: 2px 32px 2px 32px;
    justify-content: center;
    background-color: #22465A;
}

.set.is-multiple .set-items-item:after {
    display: block;
    content: '';
    position: absolute;
    width: 2px;
    top: -4px;
    height: 4px;
    left: 50%;
    margin-left: -1px;
    background-color: #22465A;
}

.sets-items-item-remove {
    position: absolute;
    right: 10px;
    top: 50%;
    margin-top: -7px;
}

.is-desktop .set-items-item:hover {
    background-color: #193443;
}

.set-input {
    padding: 0px 10px 0px 10px;
    line-height: 40px;
    font-size: 14px;
    background-color: #fff;
    font-weight: 400;
    border-radius: 4px;
    width: 100%;
}

.set-input-wrapper.is-searching .set-input {
    padding-right: 40px;
}

.set-input-wrapper.is-searching i {
    position: absolute;
    right: 0px;
    top: 0px;
    color: #999;
    width: 40px;
    height: 40px;
    text-align: center;
    transform-origin: 50% 50%;
    display: inline-block;
    vertical-align: middle;
    line-height: 40px;
    font-size: 16px;
}

.set.is-multiple .set-input {
    border-radius: 10px;
    text-align: center;
}

.set.is-multiple .set-input:after {
    display: block;
    content: '';
    position: absolute;
    width: 2px;
    top: -4px;
    height: 4px;
    left: 50%;
    margin-left: -1px;
    background-color: #22465A;
}

.set-text::placeholder {
    color: #666;
}

.set-empty {
    position: absolute;
    z-index: 100;
    width: 100%;
    min-width: 120px;
    left: 50%;
    top: calc(100% + 4px);
    -webkit-transform: translateX(-50%);
    transform: translateX(-50%);
    max-width: 300px;
    -webkit-box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    color: #082534;
    font-weight: 400;
    cursor: pointer;
    line-height: 18px;
    text-align: center;
    font-size: 14px;
    padding: 8px 10px;
    background-color: #fff;
    border-radius: 4px;
}

</style>